export interface DayEntity {
  type: string;
  label: string;
  value: string;
  aria: string;
}

export type MonthEntity = DayEntity[] | null;

export interface DateSelectEntity {
  id: string;
  value: string;
}

export interface CalendarEntity {
  yearLabel: string;
  monthLabel: string;
  calendarModel: (DayEntity | null)[][];
  yearOffset: number;
  monthOffset: number;
}

export interface BaggageCalculatorCalendarEntity {
  dateOfPurchase: CalendarEntity;
  dateOfTravel: CalendarEntity;
}
